import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";

/**
 * Deljenje pristupa bazi — i predaja i opoziv, kao njegova dva kraja.
 *
 * Do sada se ovo radilo slanjem privatnog ključa nekome. Time primalac dobija
 * KOPIJU tuđe tajne, koja se više ne može povući; ovde dobija svoj ključ na
 * ovlašćenju, pa se skida pojedinačno.
 *
 * Primalac se navodi GUIName-om, nikad ključem: javni ključ se čita sa lanca.
 * Zato `check` i postoji — da se pre potvrde vidi ČIJI je to tačno nalog, jer
 * pogrešno unet guiname koji stvarno postoji je jedina omaška koju ni jedna
 * provera ne može da uhvati.
 */
export const useShareAccess = () => {
    const [checking, setChecking] = useState(false);
    const [sharing, setSharing] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(null);
    const { selected: { selectedServer }, userData, URL } = useContext(GuiContext);

    const post = async (path, body) => {
        const res = await fetch(`${URL}${path}`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                guiname: userData?.guiname,
                server_url: selectedServer,
                ...body,
            }),
        });
        return res.json();
    };

    const check = async (database, toGuiname, privateKey) => {
        setChecking(true);
        setError(null);
        setResult(null);
        try {
            const body = await post("/api/inerygui/share_check", {
                account_name: database,
                to_guiname: toGuiname,
                private_key: privateKey || undefined,
            });
            setResult(body);
            return body;
        } catch (e) {
            setError(String(e.message || e));
            return null;
        } finally {
            setChecking(false);
        }
    };

    const share = async (database, toGuiname, privateKey, mode) => {
        setSharing(true);
        setError(null);
        try {
            const body = await post("/api/inerygui/share_access", {
                account_name: database,
                to_guiname: toGuiname,
                private_key: privateKey,
                mode,
            });
            if (!body?.status) {
                // Poruka lanca se PRENOSI. Odbijena promena ovlašćenja objasni
                // sama sebe („already has access", „no key at all"), a zamena
                // opštim tekstom bi tu obavest bacila.
                setError(body?.error || body?.message || "Could not change access.");
                return null;
            }
            setDone(body);
            return body;
        } catch (e) {
            setError(String(e.message || e));
            return null;
        } finally {
            setSharing(false);
        }
    };

    const reset = () => { setResult(null); setError(null); setDone(null); };

    return { check, share, checking, sharing, result, error, done, reset };
};
